import React, { useEffect } from 'react';
import { useSettings } from '../../context/SettingsContext';
import './AboutPage.css';

const AboutPage = () => {
  const { t } = useSettings();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-hero">
          <h1 className="about-title">{t('about')}</h1>
          <p className="about-subtitle">
            {t('aboutHeroSubtitle')}
          </p>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>📖 {t('missionSectionTitle')}</h2>
            <p>
              {t('missionSectionText')}
            </p>
          </section>

          <section className="about-section">
            <h2>🎯 {t('whatWeDoTitle')}</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">📚</div>
                <h3>{t('eLibrary')}</h3>
                <p>
                  {t('eLibraryDesc')}
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">📰</div>
                <h3>{t('newsPortal')}</h3>
                <p>
                  {t('newsPortalDesc')}
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">🤝</div>
                <h3>{t('charityPlat')}</h3>
                <p>
                  {t('charityPlatDesc')}
                </p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>💡 {t('valuesTitle')}</h2>
            <div className="values-list">
              <div className="value-item">
                <span className="value-number">01</span>
                <div className="value-content">
                  <h3>{t('valAccess')}</h3>
                  <p>{t('valAccessDesc')}</p>
                </div>
              </div>

              <div className="value-item">
                <span className="value-number">02</span>
                <div className="value-content">
                  <h3>{t('valReliability')}</h3>
                  <p>{t('valReliabilityDesc')}</p>
                </div>
              </div>

              <div className="value-item">
                <span className="value-number">03</span>
                <div className="value-content">
                  <h3>{t('valTransparency')}</h3>
                  <p>{t('valTransparencyDesc')}</p>
                </div>
              </div>

              <div className="value-item">
                <span className="value-number">04</span>
                <div className="value-content">
                  <h3>{t('valQuality')}</h3>
                  <p>{t('valQualityDesc')}</p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>📊 {t('achievementsTitle')}</h2>
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">1000+</div>
                <div className="stat-label">{t('statBooks')}</div>
              </div>

              <div className="stat-card">
                <div className="stat-number">500+</div>
                <div className="stat-label">{t('statNews')}</div>
              </div>

              <div className="stat-card">
                <div className="stat-number">100+</div>
                <div className="stat-label">{t('statUsers')}</div>
              </div>

              <div className="stat-card">
                <div className="stat-number">10+</div>
                <div className="stat-label">{t('statYears')}</div>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>🎓 {t('historyTitle')}</h2>
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-year">2016</div>
                <div className="timeline-content">
                  <h3>{t('hist2016')}</h3>
                  <p>{t('hist2016Desc')}</p>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">2018</div>
                <div className="timeline-content">
                  <h3>{t('hist2018')}</h3>
                  <p>{t('hist2018Desc')}</p>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">2021</div>
                <div className="timeline-content">
                  <h3>{t('hist2021')}</h3>
                  <p>{t('hist2021Desc')}</p>
                </div>
              </div>

              <div className="timeline-item">
                <div className="timeline-year">2026</div>
                <div className="timeline-content">
                  <h3>{t('hist2026')}</h3>
                  <p>{t('hist2026Desc')}</p>
                </div>
              </div>
            </div>
          </section>

          <section className="about-section cta-section">
            <h2>{t('joinUsTitle')}</h2>
            <p className="cta-text">
              {t('joinUsText')}
            </p>
            <div className="cta-buttons">
              <a href="/library" className="cta-button primary">
                {t('readBooksBtn')}
              </a>
              <a href="/news" className="cta-button secondary">
                {t('readNewsBtn')}
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
